import {
  CREATE_BILLING_CYCLE,
  FETCH_ALL_BILLING_CYCLE,
  FETCH_DAILY_PAYMENTS,
  FETCH_ONE_BILLING_CYCLE,
} from "../actions/constants";

const billingCycle = (
  state = { billingCycles: [], payments: [], billingCycle: {} },
  action
) => {
  switch (action.type) {
    case FETCH_ALL_BILLING_CYCLE:
      return {
        ...state,
        billingCycles: action.payload,
      };
    case FETCH_ONE_BILLING_CYCLE:
      return {
        ...state,
        billingCycle: action.payload,
      };

    case CREATE_BILLING_CYCLE:
      console.log(state.billingCycles);
      return {
        ...state,
        billingCycles: [...state.billingCycles, action.payload],
      };
    case FETCH_DAILY_PAYMENTS:
      return {
        ...state,
        payments: action.payload,
      };

    default:
      return state;
  }
};

export default billingCycle;
